import { defineMessage } from '@lingui/macro';

import InputNumber from '../../generic/form/InputNumber';
import ShopFeaturesBloc from './features/ShopFeaturesBloc';

const ShopResourceBookByQuantity = ({ shopResource, setShopResource, dataWidthProps, data }) => {
  return (
    <>
      <InputNumber
        fieldLabel={defineMessage({ message: 'Quantity' })}
        fieldValue={shopResource.quantity}
        fieldMaximum={shopResource.stock != null ? shopResource.stock : undefined}
        onChange={(fieldName, newValue) => setShopResource(newValue)}
        isRequired
        {...dataWidthProps}
      />

      <ShopFeaturesBloc data={data} dataWidthProps={dataWidthProps} />
    </>
  );
};

export default ShopResourceBookByQuantity;
